import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { EventManagerComponent } from './components/event-manager/event-manager.component';
import { IsAuthenticatedGuard } from './_guards/is-authenticated.guard';
import { IsNotAuthenticatedGuard } from './_guards/is-not-authenticated.guard';
import { EventDetailsComponent } from './components/event-details/event-details.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { VenuesComponent } from './components/venues/venues.component';
import { EventsPanelComponent } from './components/events/events-panel/events-panel.component';
import { LoginWithRefreshTokenComponent } from './components/login-with-refresh-token/login-with-refresh-token.component';
import {ReportsComponent} from "./components/reports/reports.component";

const routes: Routes = [

  // { path: 'sign-up', component: SignupComponent, canActivate: [IsNotAuthenticatedGuard] },
  { path: 'login', component: LoginComponent, canActivate: [IsNotAuthenticatedGuard] },
  { path: 'login/:refresh-token', component: LoginWithRefreshTokenComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [IsNotAuthenticatedGuard] },
  { path: 'event/users', component: ChangePasswordComponent, canActivate: [IsNotAuthenticatedGuard] },
  { path: 'privacy-policy', component: PrivacyPolicyComponent},
  { path: 'promoter/venues', component: VenuesComponent, canActivate: [IsAuthenticatedGuard] },
  { path: 'promoter/events', component: EventsPanelComponent, canActivate: [IsAuthenticatedGuard] },
  { path: 'promoter/event-manager', component: EventManagerComponent, canActivate: [IsAuthenticatedGuard]},
  { path: 'promoter/event-manager/:id',component: EventDetailsComponent,canActivate: [IsAuthenticatedGuard]},
  { path: 'venues/:venue-id/reports',component: ReportsComponent, canActivate: [IsAuthenticatedGuard]},
  { path: 'promoter', redirectTo: 'promoter/venues', pathMatch: 'full'},
  { path: '', redirectTo: 'promoter/venues', pathMatch: 'full'},
  // { path: 'page-not-found', component: PageNotFoundComponent, canActivate: [IsAuthenticatedGuard] },
  // { path: '**', redirectTo: '/page-not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
